import { Buffer } from "buffer";
import { DownloadFileData } from "../features/api-interfaces";

export const toBlobExcel = (base64: string): Blob => {
  // Base64文字列からバイナリデータへデコード
  const bin = Buffer.from(base64, "base64");
  // BufferからUint8Arrayへの変換
  const buffer = Uint8Array.from(bin);
  // blob作成
  const blob = new Blob([buffer.buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  return blob;
};

/**
 * Base64のファイルデータのダウンロード処理.
 * @param {DownloadFileData} file
 */
export const downloadBase64File = (file: DownloadFileData) => {
  const fileName = file.originalFileName;
  const fileData = file.fileDataBase64;

  // base64でエンコードされたエクセルファイルをblob化
  const blob = toBlobExcel(fileData);
  // url作成
  const url = window.URL.createObjectURL(blob);

  // ダウンロード用のリンク作成
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;

  // ダウンロード実行
  link.click();

  // url解放
  window.URL.revokeObjectURL(url);
};
